const DEV = true;

const DEV_PARAMS = {
    apiUri: "http://localhost:15000/api",
    homePage: "http://localhost:3000/inicio",
    dataUri: 'https://lex.eac.com.ar/data'
};

const PROD_PARAMS = {
    apiUri: "https://lex.eac.com.ar:16621/api",
    homePage: "https://lex.eac.com.ar/inicio",
    dataUri: 'https://lex.eac.com.ar/data'
};

const COLORS = {
    green: '#28A745',
    brand_primary: '#EDCD1E',
    brand_secondary: '#EDCD1E'
}

export const params = function () {
    if(DEV){
        return DEV_PARAMS;
    }else{
        return PROD_PARAMS;
    }
}

export const colors = function () {
    return COLORS;
}